import React, { useEffect } from "react";
import _ from 'lodash';

const { useInView } = require("react-intersection-observer");

const useDelayedInView = ({ root, rootMargin, threshold, skip, onChange }) => {
  const timeoutId = React.useRef(null);

  const [ref, visible, entry] = useInView({
    root: root,
    rootMargin: rootMargin,
    threshold: threshold,
    skip: skip
  });

  const intersectionRatio = _.get(entry, 'intersectionRatio');

  useEffect(() => {
    const isIntersecting = _.get(entry, 'isIntersecting');
    const intersectionRatio = _.get(entry, 'intersectionRatio');

    if (isIntersecting || intersectionRatio > 0) {
      _delayElementEnteredCheck();
    } else {
      _handleElementExited()
    }

    return () => {
      _clearTimeout();
    }
  }, [entry, intersectionRatio]);

  const _delayElementEnteredCheck = () => {
    if (timeoutId.current) {
      return;
    }

    timeoutId.current = setTimeout(() => {
      _handleElementEntered();
    }, 500);
  }

  const _handleElementEntered = () => {
    onChange(true);
    _clearTimeout();
  }

  const _handleElementExited = () => {
    _clearTimeout();
    onChange(false);
  }

  const _clearTimeout = () => {
    if (!timeoutId.current) {
      return;
    }

    clearTimeout(timeoutId.current);
    timeoutId.current = null;
  }

  return [ref, visible];
}

export default useDelayedInView;